<div style="width: 100%; height: 100%">

    <div  id="add_notifcation-modal" *ngIf="modalTitle == 'Add Notification'" [formGroup]="addNotificationForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Contact Notification</mat-label>
            </div>  
            <br>     
            <mat-form-field style="width: 100%;">
                <mat-label>Contact person</mat-label>
                <mat-select formControlName="name" required>
                    <mat-option *ngFor="let type of typeListContact"
                        [value]="type">{{type}}</mat-option>
                </mat-select>                
            </mat-form-field>   
            <mat-checkbox formControlName="at_pick_up">At Pick Up</mat-checkbox>   <br>
            <mat-checkbox formControlName="delayed_pick_up">Delayed Pick Up</mat-checkbox>   <br>
            <mat-checkbox formControlName="at_delivery">At Delivery</mat-checkbox>   <br>
            <mat-checkbox formControlName="delayed_delivery">Delayed Delivery</mat-checkbox>   
            <mat-checkbox formControlName="assessorials_incurred">Assessorials Incurred</mat-checkbox>   
            <mat-checkbox formControlName="phone_notification">Phone Notification</mat-checkbox>   
            <mat-checkbox formControlName="sms_notification">SMS Notification</mat-checkbox>   
            <mat-checkbox formControlName="email_notification">Email Notification</mat-checkbox>   
            <mat-checkbox formControlName="appointment_pickup">Appointment Pick Up</mat-checkbox>   
            <mat-checkbox formControlName="appointment_delivery">Appointment Delivery</mat-checkbox>   
            <input matInput type="string" formControlName="contact_uuid" hidden >   
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addNotification()" >Add Notification</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="edit_notication-modal" *ngIf="modalTitle == 'Edit Notification'" [formGroup]="editNotificationForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit Contact Notification</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Contact person</mat-label>
                <mat-select formControlName="name" required>
                    <mat-option *ngFor="let type of typeListContact"
                        [value]="type">{{type}}</mat-option>
                </mat-select>                
            </mat-form-field>   
            <mat-checkbox formControlName="at_pick_up">At Pick Up</mat-checkbox>   <br>
            <mat-checkbox formControlName="delayed_pick_up">Delayed Pick Up</mat-checkbox>   <br>
            <mat-checkbox formControlName="at_delivery">At Delivery</mat-checkbox>   <br>
            <mat-checkbox formControlName="delayed_delivery">Delayed Delivery</mat-checkbox>   
            <mat-checkbox formControlName="assessorials_incurred">Assessorials Incurred</mat-checkbox>   
            <mat-checkbox formControlName="phone_notification">Phone Notification</mat-checkbox>   
            <mat-checkbox formControlName="sms_notification">SMS Notification</mat-checkbox>   
            <mat-checkbox formControlName="email_notification">Email Notification</mat-checkbox>   
            <mat-checkbox formControlName="appointment_pickup">Appointment Pick Up</mat-checkbox>   
            <mat-checkbox formControlName="appointment_delivery">Appointment Delivery</mat-checkbox>   
            <input matInput type="string" formControlName="contact_uuid" hidden >   
            <input matInput type="string" formControlName="contact_profile_default_notification_uuid" hidden >   
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editNotification()" >Update</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Notification Confirmation'" [formGroup]="deleteNotificationForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Notification?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Name</mat-label>
                <input matInput type="string" formControlName="name" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_profile_default_notification_uuid" hidden >                    
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteNotification()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_note-modal" *ngIf="modalTitle == 'Add Note'" [formGroup]="addNoteForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Contact Note</mat-label>
            </div>  
            <br>     
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Note</mat-label>
                <input matInput formControlName="contact_note">
            </mat-form-field>      
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addNote()" >Add Note</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="edit_note-modal" *ngIf="modalTitle == 'Edit Note'" [formGroup]="editNoteForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit Contact Note</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Note</mat-label>
                <input matInput formControlName="contact_note">
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editNote()" >Update</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Note Confirmation'" [formGroup]="deleteNoteForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Note?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Note</mat-label>
                <input matInput type="string" formControlName="contact_note" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_note_uuid" hidden >                    
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteNote()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_email-modal" *ngIf="modalTitle == 'Add Email'" [formGroup]="addEmailForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Email Address</mat-label>
            </div>  
            <br>     
            <mat-form-field style="width: 100%;">
                <mat-label>Email Label</mat-label>
                <input matInput formControlName="email_label">
            </mat-form-field>      
            <mat-form-field style="width: 100%;">
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="email_address">
            </mat-form-field>                                   
            <mat-form-field style="width: 100%;">
                <mat-label>Description</mat-label>
                <input matInput formControlName="email_description">
            </mat-form-field>            
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addEmail()" >Add Email</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="edit_email-modal" *ngIf="modalTitle == 'Edit Email'" [formGroup]="editEmailForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit Contact Email</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Email Label</mat-label>
                <input matInput formControlName="email_label">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="email_address">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Email Description</mat-label>
                <input matInput formControlName="email_description">
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editEmail()" >Update</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Email Confirmation'" [formGroup]="deleteEmailForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Email?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Email Address</mat-label>
                <input matInput type="string" formControlName="email_address" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_email_uuid" hidden >                    
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteEmail()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_url-modal" *ngIf="modalTitle == 'Add URL'" [formGroup]="addURLForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Contact URL</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>URL Type</mat-label>
                <input matInput formControlName="url_type">
                <input matInput type="string" formControlName="contact_uuid" hidden >  
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Label</mat-label>
                <input matInput formControlName="url_label">
            </mat-form-field>
            <mat-checkbox formControlName="url_primary">Primary</mat-checkbox>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Address</mat-label>
                <input matInput formControlName="url_address">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Description</mat-label>
                <input matInput formControlName="url_description" type="number">
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addURL()" >Add</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_service-modal" *ngIf="modalTitle == 'Upload Contact Document'" [formGroup]="uploadDocumentForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Upload Contact Document</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Document Type</mat-label>
                <mat-select formControlName="document_type" required>
                    <mat-option *ngFor="let type of documentType"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>description</mat-label>
                <input matInput formControlName="file_description">
            </mat-form-field>            
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="uploadDocumentType()" >Upload</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="edit_url-modal" *ngIf="modalTitle == 'Edit URL'" [formGroup]="editURLForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit Contact URL</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>URL Type</mat-label>
                <input matInput formControlName="url_type">
                <input matInput type="string" formControlName="contact_url_uuid" hidden >  
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Label</mat-label>
                <input matInput formControlName="url_label">
            </mat-form-field>
            <mat-checkbox formControlName="url_primary">Primary</mat-checkbox>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Address</mat-label>
                <input matInput formControlName="url_address">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Description</mat-label>
                <input matInput formControlName="url_description">
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editURL()" >Update</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_url-modal" *ngIf="modalTitle == 'Add URL'" [formGroup]="addURLForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Contact URL</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>URL Type</mat-label>
                <input matInput formControlName="url_type">
                <input matInput type="string" formControlName="contact_uuid" hidden >  
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Label</mat-label>
                <input matInput formControlName="url_label">
            </mat-form-field>
            <mat-checkbox formControlName="url_primary">Primary</mat-checkbox>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Address</mat-label>
                <input matInput formControlName="url_address">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>URL Description</mat-label>
                <input matInput formControlName="url_description" type="number">
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addURL()" >Add</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete URL Confirmation'" [formGroup]="deleteURLForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this URL?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Type</mat-label>
                <input matInput type="string" formControlName="url_address" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_url_uuid" hidden >                    
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteURL()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_type-modal" *ngIf="modalTitle == 'Add Contact Type'" [formGroup]="addTypeForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Contact Type</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Type</mat-label>
                <mat-select formControlName="contact_type"  required (selectionChange)="onTypeChange()">
                    <mat-option *ngFor="let type of contactTypeList" [value]="type">{{type}}</mat-option>
                </mat-select>
                <input matInput type="string" formControlName="contact_uuid" hidden >    
                <input matInput type="number" formControlName="contact_type_no" hidden >    
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addType()" >Add</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Contact Type Confirmation'" [formGroup]="deleteTypeForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Contact Type?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Type</mat-label>
                <input matInput type="string" formControlName="contact_type" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_type_uuid" hidden >                    
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteType()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_service-modal" *ngIf="modalTitle == 'Add Default Service'" [formGroup]="addDefaultServiceForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Default Service</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Carrier Service</mat-label>
                <mat-select formControlName="carrier_service" required>
                    <mat-option *ngFor="let type of typeListService" [value]="type">{{type}}</mat-option>
                </mat-select>
                <input matInput type="string" formControlName="contact_uuid" hidden >    
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Carrier Service Type</mat-label>
                <mat-select formControlName="carrier_service_type" required>
                    <mat-option *ngFor="let type of typeListServiceType"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addDefaultService()" >Add</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_service-modal" *ngIf="modalTitle == 'Add Service'" [formGroup]="addServiceForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Carrier Service</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Carrier Service</mat-label>
                <mat-select formControlName="carrier_service" required>
                    <mat-option *ngFor="let type of typeListService" [value]="type">{{type}}</mat-option>
                </mat-select>
                <input matInput type="string" formControlName="contact_uuid" hidden >    
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Carrier Service Type</mat-label>
                <mat-select formControlName="carrier_service_type" required>
                    <mat-option *ngFor="let type of typeListServiceType"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Option</mat-label>
                <input matInput formControlName="service_option">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Currency Type</mat-label>
                <input matInput formControlName="currency_type">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Flat Rate</mat-label>
                <input matInput formControlName="flat_rate" type="number">
            </mat-form-field>
            <mat-checkbox formControlName="service_taxed">Service Taxed</mat-checkbox>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Tax Multiplier</mat-label>
                <input matInput formControlName="service_tax_multiplier" type="number">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Tax Cost</mat-label>
                <input matInput formControlName="service_tax_cost" type="number">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Note</mat-label>
                <input matInput formControlName="service_note">
            </mat-form-field>    
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addService()" >Add</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Edit Default Service'" [formGroup]="editDefaultServiceForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit Default Service</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Service</mat-label>
                <mat-select formControlName="service" required>
                    <mat-option *ngFor="let type of typeListService" [value]="type">{{type}}</mat-option>
                </mat-select>
                <input matInput type="string" formControlName="contact_profile_default_service_uuid" hidden > 
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Type</mat-label>
                <mat-select formControlName="service_type" required>
                    <mat-option *ngFor="let type of typeListServiceType"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>          
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editDefaultService()" >Save</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_service-modal" *ngIf="modalTitle == 'Edit Service'" [formGroup]="editServiceForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit Carrier Service</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Carrier Service</mat-label>
                <mat-select formControlName="carrier_service" required>
                    <mat-option *ngFor="let type of typeListService" [value]="type">{{type}}</mat-option>
                </mat-select>
                <input matInput type="string" formControlName="carrier_service_rate_uuid" hidden >    
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Carrier Service Type</mat-label>
                <mat-select formControlName="carrier_service_type" required>
                    <mat-option *ngFor="let type of typeListServiceType"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Option</mat-label>
                <input matInput formControlName="service_option">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Currency Type</mat-label>
                <input matInput formControlName="currency_type">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Flat Rate</mat-label>
                <input matInput formControlName="flat_rate" type="number">
            </mat-form-field>
            <mat-checkbox formControlName="service_taxed">Service Taxed</mat-checkbox>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Tax Multiplier</mat-label>
                <input matInput formControlName="service_tax_multiplier" type="number">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Tax Cost</mat-label>
                <input matInput formControlName="service_tax_cost" type="number">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Note</mat-label>
                <input matInput formControlName="service_note">
            </mat-form-field>    
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editService()" >Edit</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Default Service Confirmation'" [formGroup]="deleteDefaultServiceForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Service?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Default Service</mat-label>
                <input matInput type="string" formControlName="service" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_profile_default_service_uuid" hidden >                    
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Default Service Type</mat-label>
                <input matInput type="string" formControlName="service_type" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
            </mat-form-field>            
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteDefaultService()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Service Confirmation'" [formGroup]="deleteServiceForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Service?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Carrier Service</mat-label>
                <input matInput type="string" formControlName="carrier_service" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="carrier_service_rate_uuid" hidden >                    
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Carrier Service Type</mat-label>
                <input matInput type="string" formControlName="carrier_service_type" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
            </mat-form-field>            
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteService()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete SubContact Confirmation'" [formGroup]="deletePhoneForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Phone?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Number</mat-label>
                <input matInput type="string" formControlName="phone_number" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_phone_uuid" hidden >                    
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deletePhone()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="edit_phone-modal" *ngIf="modalTitle == 'Edit Sub Contact'" [formGroup]="editPhoneForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit Phone</mat-label>
            </div>  
            <br>       
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Name</mat-label>
                <input matInput formControlName="contact_name">
            </mat-form-field>               
            <mat-form-field style="width: 100%;">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="contact_name_given">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="contact_name_family">
            </mat-form-field>            
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Type</mat-label>
                <mat-select formControlName="phone_type" required>
                    <input matInput type="string" formControlName="contact_uuid" hidden >   
                    <input matInput type="string" formControlName="contact_phone_uuid" hidden >                     
                    <mat-option *ngFor="let type of typeListPhone" [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>             
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Number</mat-label>
                <input matInput formControlName="phone_number">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Extension</mat-label>
                <input matInput formControlName="phone_extension">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Description</mat-label>
                <input matInput formControlName="phone_description">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="contact_email">
            </mat-form-field><br> 
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editPhone()" >Update</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_phone-modal" *ngIf="modalTitle == 'Add Sub Contact'" [formGroup]="addPhoneForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Phone</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Contact Name</mat-label>
                <input matInput formControlName="contact_name">
            </mat-form-field>            
            <mat-form-field style="width: 100%;">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="contact_name_given">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="contact_name_family">
            </mat-form-field>            
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Type</mat-label>
                <mat-select formControlName="phone_type" required>
                    <mat-option *ngFor="let type of typeListPhone" [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Number</mat-label>
                <input matInput formControlName="phone_number">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Extension</mat-label>
                <input matInput formControlName="phone_extension">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Phone Description</mat-label>
                <input matInput formControlName="phone_description">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="contact_email">
            </mat-form-field><br> 
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="addPhone()" >Create</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="edit_address-modal" *ngIf="modalTitle == 'Edit Contact Address'" [formGroup]="editAddressForm">
        <div class="upload-modal-inner">
            <div class="upload-modal-content">
                <mat-label style = "font-size: 16px;">Edit Address</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Address Type</mat-label>
                <mat-select formControlName="address_type" required>
                    <input matInput type="string" formControlName="contact_uuid" hidden >   
                    <input matInput type="string" formControlName="contact_address_uuid" hidden >    
                    <mat-option *ngFor="let type of typeList" [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Street</mat-label>
                <input matInput formControlName="address_street"  required>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Extended</mat-label>
                <input matInput formControlName="address_extended">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Community</mat-label>
                <input matInput formControlName="address_community">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address City</mat-label>
                <input matInput formControlName="address_locality">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Country</mat-label>
                <mat-select formControlName="address_country" required
                    (selectionChange)="onCountryChange()">
                    <mat-option *ngFor="let type of typeListCountry"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address State/Province</mat-label>
                <mat-select formControlName="address_region" required>
                    <mat-option
                        *ngFor="let type of getAddressStates(editAddressForm.get('address_country')?.value)"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Postal Code</mat-label>
                <input matInput formControlName="address_postal_code">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Description</mat-label>
                <input matInput formControlName="address_description">
            </mat-form-field>        
            <div class="spinner-overlay" *ngIf="spinner">
                <button class="btn btn-primary" type="button" disabled>
                    <span class="loader" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Processing...</span>
                </button>
                <button class="btn btn-primary" type="button" disabled>
                    <span class="loader" role="status" aria-hidden="true"></span>
                    Processing...
                </button>
            </div>            
            <div class="upload-modal-buttons" *ngIf="!spinner">
                <button type="button" class="confirm"  (click)="editAddress()" >Update</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Address Confirmation'" [formGroup]="deleteAddressForm">
        <div class="upload-modal-inner">
            <div class="upload-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Address?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Address</mat-label>
                <input matInput type="string" formControlName="address_street" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_address_uuid" hidden >                    
            </mat-form-field>
            <div class="upload-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteAddress()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_address-modal" *ngIf="modalTitle == 'Add Contact Address'" [formGroup]="addAddressForm">
        <div class="upload-modal-inner">
            <div class="upload-modal-content">
                <mat-label style = "font-size: 16px;">Add Address</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Address Type</mat-label>
                <mat-select formControlName="address_type" required>
                    <input matInput type="string" formControlName="contact_uuid" hidden >    
                    <mat-option *ngFor="let type of typeList" [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Street</mat-label>
                <input matInput formControlName="address_street"  required>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Extended</mat-label>
                <input matInput formControlName="address_extended">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Community</mat-label>
                <input matInput formControlName="address_community">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address City</mat-label>
                <input matInput formControlName="address_locality">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Country</mat-label>
                <mat-select formControlName="address_country" required
                    (selectionChange)="onCountryChange()">
                    <mat-option *ngFor="let type of typeListCountry"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address State/Province</mat-label>
                <mat-select formControlName="address_region" required>
                    <mat-option
                        *ngFor="let type of getAddressStates(addAddressForm.get('address_country')?.value)"
                        [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Postal Code</mat-label>
                <input matInput formControlName="address_postal_code">
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Address Description</mat-label>
                <input matInput formControlName="address_description">
            </mat-form-field>        
            <div class="spinner-overlay" *ngIf="spinner">
                <button class="btn btn-primary" type="button" disabled>
                    <span class="loader" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Processing...</span>
                </button>
                <button class="btn btn-primary" type="button" disabled>
                    <span class="loader" role="status" aria-hidden="true"></span>
                    Processing...
                </button>
            </div>                
            <div class="upload-modal-buttons" *ngIf="!spinner">
                <button type="button" class="confirm"  (click)="addAddress()" >Create</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>


</div>